export default __webpack_public_path__ + "static/media/hearth.4456a878.svg";